<template>
  <div>
    <!-- === Gatilho do Alert" na aba habilitacao-juridica - apenas em processos de alteração === -->
    <v-alert 
      v-if="contratoSocialAlteradoConfirmado && isAlteracao && acaoTela === 'alterar'"
      type="info"
      outlined
      dismissible
      class="ma-4 mb-6"
      @input="contratoSocialAlteradoLocal = false"
    >
      <v-row align="center">
        <v-col class="grow">
          <div class="font-weight-medium">
            <v-icon color="info" class="mr-2">info</v-icon>
            <strong>Atenção!</strong> 
            Você alterou o <strong>Contrato Social</strong>. 
          </div>
          <div class="mt-2 text--secondary">
            Será necessário atualizar o <strong>Cartão CNPJ</strong> na aba 
            "Regularidade Fiscal e Trabalhista" antes de finalizar o cadastro.
          </div>
        </v-col>
      </v-row>
    </v-alert>    

    <v-form v-model="valid" ref="docHabilitacaoJuridicaForm">
      <v-flex p-b-30 v-for="doc in listaDocFornecSolicitacao.filter(documento =>
          documento.numHabilitacao === '2'
          &&   documento.codDocumento != 32
          && (
            (model.finalidadeEmpresa == 0 && documento.indSemFinsLucrativos != '1') 
            || (model.finalidadeEmpresa == 1 && documento.indSemFinsLucrativos != '1' && model.flagSociedadeAnonima == 1)
            || (model.finalidadeEmpresa == 1 && documento.indComFinsLucrativos != '1' && (model.flagSociedadeAnonima == 0 || model.flagSociedadeAnonima === null))
          ))" :key="doc.codDocumento">
      <div class="p-t-20 p-b-20">
          <div class="tituloBox border-top">
            <div class="bg-red barraTitulo"></div>
            <h1 class="text-default font-size-14">        
              <strong>{{getDescricaoDocumento(doc)}}</strong>        
              <popper v-if="model.flagEstrangeiro === '1'" :stop-propagation="true" :options="{placement: 'right'}">
                <div class="popper">
                  Ou documento equivalente conforme Lei nº 9.433/2005
                </div>
                <button prevent-default="true" type="button" class="san" slot="reference">
                  <v-icon        
                    class="mx-1 san"
                    slot="activator"
                    :size="25"
                    color="primary"
                    style="margin-top:-6px"
                  >info</v-icon>
                </button>
              </popper>
              <popper v-if="doc.codDocumento === 146" :stop-propagation="true" :options="{placement: 'right'}">
                <div class="popper">
                  Contrato Social e Ultima Alteração (se houver)
                </div>
                <button prevent-default="true" type="button" class="san"  slot="reference" >
                  <v-icon        
                    class="mx-1 san"
                    slot="activator"
                    :size="25"
                    color="primary"
                    style="margin-top:-6px"
                  >info</v-icon>
                </button>
              </popper>
            </h1>
          </div>
        </div>
    
      <div class="clear"></div>  
        <v-card>
          <v-layout row wrap>
              <v-flex xs4>
                <datePicker
                  v-model="doc.docSolicitacao.datExpedicao"        
                  :dataDefault="doc.docSolicitacao.datExpedicao"
                  :key="dataContratoSocialKey"
                  v-mask="maskData"
                  :rules="[v=>validaIfObrigatorio(v,doc)  || $t('messages.validacao.campoObrigatorio')]"
                  :limitarData="true"
                  :label="'Data do(a) '+  titleCase(doc.nomDocumento)  + testeAsterico(doc)"
                  :required="doc.indSemFinsLucrativos == '3' || doc.indComFinsLucrativos == '3' || (doc.Documento === 'ATA'  && model.finalidadeEmpresa === 0 )"
                  validate-on-blur
                  @change="onDocumentoAlterado(doc.docSolicitacao, doc.codDocumento)"
                />
              </v-flex>         
              <v-flex inputIcon xs8 v-show="doc.docSolicitacao.arquivoUpload != null">
                <v-text-field
                  :value="subStrUpload(doc.docSolicitacao.arquivoUpload,'Anexo do '+ titleCase(doc.nomDocumento))"
                  :label="'Anexo do(a) '+ titleCase(doc.nomDocumento) + testeAsterico(doc)"
                  clearable
                  append-icon="get_app"
                  readonly
                  @click:append="baixarArquivo(doc.docSolicitacao.arquivoUpload)"
                  @click:clear="onArquivoLimpo(doc)"
                  :rules="[isAnexoValido(doc) || $t('messages.validacao.documentoInvalido')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs8 v-if="doc.docSolicitacao.arquivoUpload == null">
                <uploadFile
                  tamanhoMaximo="30MB"
                  :required="doc.indSemFinsLucrativos == '3' || doc.indComFinsLucrativos == '3' || (doc.nomDocumento === 'ATA' && model.finalidadeEmpresa === 0)"
                  :label="'Anexar '+ titleCase(doc.nomDocumento) + testeAsterico(doc)"
                  v-model="doc.file"
                  @input="onNovoArquivo(doc)"
                  accept=".pdf, .PDF"
                />
              </v-flex>               
          </v-layout>
        </v-card>
      </v-flex>
    </v-form>
    <v-layout row wrap class="p-t-10" v-if="!crud.show">
      <v-flex sm2 class="left p-l-10" v-if="model.finalidadeEmpresa == 1 && model.flagSociedadeAnonima == 0 || model.finalidadeEmpresa == 1 && model.flagSociedadeAnonima == 1">
        <v-btn 
          slot="activator" 
          color="primary" 
          class="mb-2" 
          @click="fnCrud('S')"
          :disabled="false"
          >Incluir Sócio</v-btn>
      </v-flex>
      <v-flex sm2 class="left" v-if="model.finalidadeEmpresa == 0 || model.finalidadeEmpresa == 1 && model.flagSociedadeAnonima == 1">
        <v-btn
          slot="activator"
          color="primary"
          class="mb-2"
          @click="fnCrud('D')"
          :disabled="false"
        >Incluir Dirigente</v-btn>
      </v-flex>
      <!-- <div class="left p-l-10" style="color:red;" v-if="sociedade_completa"><h3 style="font-size:bold">Empresa com quadro societário completo </h3></div> -->
  </v-layout>
      <dirigentesSociosCrud
        :model="model"
        :modelEdit="modelEdit"
        :habilitacaoLista="habilitacaoLista"
        :erroHabilitacaoJuridica="erroHabilitacaoJuridica"
        :crud="crud"
        v-if="crud.show"
      />
      <dirigentesTable 
        :model="model" 
        :habilitacaoLista="habilitacaoLista" 
        :erroHabilitacaoJuridica="erroHabilitacaoJuridica"
      />
      <sociosTable 
        v-on:editarItem="fnEdit($event)"
        :model="model" 
        :habilitacaoLista="habilitacaoLista" 
        :erroHabilitacaoJuridica="erroHabilitacaoJuridica"
      />
  </div>
</template>

<script>
import dirigentesTable from "./components/dirigentes-table";
import sociosTable from "./components/socios-table";
import dirigentesSociosCrud from "./components/dirigentesSocios-crud";
import util from "../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import fornecedorService from "../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */

export default {
  name: "hablitacao-juridica",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    OldModel: Object,
    isAlteracao: Boolean,
    acaoTela: String,
    erroHabilitacaoJuridica:Object,
    upload: Object,
    listaDocFornecSolicitacao: Array,
    hasErroDocHabilitacao: Boolean
   
  },
  components: { /*Componentes utilizados*/
    dirigentesTable,
    sociosTable,
    dirigentesSociosCrud
  },
  watch: { //Propriedades assistidas
    "model.dataContratoSocial": {
      handler(newValue, oldValue) {
        if (newValue != null && oldValue!=null )
        {
          if (this.isAlteracao && newValue.substring(0, 10) !== oldValue.substring(0, 10)) {
            //Se alterar a data de contrato, obrigar a anexar o contrato novamente
            //this.model.arquivoUpload = null
            //this.upload.novoAnexoContratoSocial = true
          }
        }
      },
    },
    'doc.docSolicitacao.datExpedicao'(nova, antiga) {
      console.log('Data mudou:', antiga, '=>', nova)
      // sua lógica aqui
    },
    model(newV,oldV){
      if(newV != oldV){
        this.listarFornecedorHabilitacaoJuridica();
      }
    },
  },
  created() {
    // ESCUTAR CONFIRMAÇÃO DO MIXIN
    this.$root.$on('contratoSocialAlteradoConfirmado', (data) => {
      console.log('DEBUG hab-juridica: CONFIRMAÇÃO do mixin:', data);
      this.contratoSocialAlteradoConfirmado = true;
    });
  },
  mounted(){
    if(this.hasErroDocHabilitacao){
      this.$refs.docHabilitacaoJuridicaForm.validate();
    }
  },
  data() {//Declaracao de variaveis
    return {
      sociedade_completa : false,
      novoAnexoContratoSocial:false,
      dataContratoSocialKey: 1,
      crud: {
        tipoCadastro: null,
        show: false
      },
      habilitacaoLista: {
        sociosLista: [],
        dirigentesLista: []
      },
      modelEdit: {},
      valid: false,
      flagContratoSocialAlterado: false,
      contratoSocialAlteradoLocal: false,
      contratoSocialAlteradoConfirmado: false,      
    };
  },
  methods: {//Declaracao de todos os metodos

    // atualizar_mesagem(){
    //   this.sociedade_completa = false;
    // },
   

    fnCrud(tipoCadastro) {
      let percentualTotal = 0;
      if(this.habilitacaoLista.sociosLista){
        this.habilitacaoLista.sociosLista.forEach(item => {

          percentualTotal += parseFloat( String(item.percentual).replace(",","."));
        });
      }

      // if(percentualTotal >= 100.0){
      //   this.sociedade_completa = true;
      //   return;
      // }else{
      //   this.sociedade_completa = false;
      // }

      setTimeout(() => {
        this.crud.tipoCadastro = tipoCadastro;
        this.crud.show = true;
      }, 200);
    },
    validaIfObrigatorio(v, validar) {
      //validar se o documento é obrigatorio
       if(validar){ // validar.indSemFinsLucrativos e validar.indComFinsLucrativos são do tipo number
        if (validar.indSemFinsLucrativos === 3 || validar.indComFinsLucrativos === 3
        ) {
          return !!v;
        }else if((validar.nomDocumento === 'ATA') && (this.model.finalidadeEmpresa === 0)){
           return !!v;
        }else {
          return true;
        }
       }else{
         return true;
       }
    },
    testeAsterico(validar){
      //teste de obrigatoriedade
      if(validar){ // validar.indSemFinsLucrativos e validar.indComFinsLucrativos são do tipo number
        if (validar.indSemFinsLucrativos === 3 || validar.indComFinsLucrativos === 3
        ) {
          return " *";
        }else if((validar.nomDocumento === 'ATA') && (this.model.finalidadeEmpresa === 0)) {
          return " *";
        }else {
          return "";
        }
       }else{
         return "";
       }
    },
    listarFornecedorHabilitacaoJuridica() {
      //resgatar os socios ou dirigentes

      if(this.model == null || this.model.fornecedoresHabilitacaoJuridica == null) return;
            
      this.habilitacaoLista.sociosLista = [];
      this.habilitacaoLista.dirigentesLista = [];
      this.model.fornecedoresHabilitacaoJuridica.filter(item => {
        if (item.tipoCadastro === "D") {
          this.habilitacaoLista.dirigentesLista.push(item);
        } else {
          this.habilitacaoLista.sociosLista.push(item);
        }
      });
    },
    titleCase(str) {
      //formatar a string para colocar as letras inicias maiusculas
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(' ');
    },

    baixarArquivo(arquivo) {
      //baixar o documento
     const numCgcFornecedor = this.$verificaPerfilCadastrador() ? this.model.numCgcFornecedor.replace(/[\W_]+/g, "") : null;
      fornecedorService.baixarArquivo(arquivo,numCgcFornecedor);
    },

    limparArquivo(doc) {
      //item da iteração mudar
      doc.docSolicitacao.arquivoUpload=null;
      doc.file=null
      if (this.isAlteracao)
      {
        doc.docSolicitacao.datExpedicao = null
        this.dataContratoSocialKey++;
      }
    },

    fnEdit(modelEdit) {
      this.sociedade_completa = false;
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      this.modelEdit = Object.assign({}, modelEdit);
      this.crud.show = false;
      setTimeout(() => {
        this.crud.tipoCadastro = this.modelEdit.tipoCadastro;
        this.crud.acao = "edit";
        this.crud.show = true;
        this.$removePreload(); /*Ocultar o PreLoad*/
      }, 200);
      document.scrollingElement.scrollTop = 0;
    },


    onDocumentoAlterado(docSolicitacao, codDocumento) {
      docSolicitacao.arquivoUploadSituacao = null;
      docSolicitacao.idMotivoIndeferimentoArquivo = null;
      docSolicitacao.dtArquivoUploadRejeicao = null;

      // 🔧 SINCRONIZAR com model.documentosSolicitacao
      if (codDocumento === 146 && this.model.documentosSolicitacao) {
        const contratoIndex = this.model.documentosSolicitacao.findIndex(doc => doc.codDocumento === 146);
        if (contratoIndex >= 0) {
          // Atualizar data no model principal
          this.model.documentosSolicitacao[contratoIndex].datExpedicao = docSolicitacao.datExpedicao;
          console.log('DEBUG: SINCRONIZOU data para model.documentosSolicitacao:', {
            novaData: docSolicitacao.datExpedicao,
            index: contratoIndex
          });
        }
      }
      
      // Detectar alteração no Contrato Social
      if (codDocumento === 146) {
        console.log('DEBUG hab-juridica: Data do Contrato Social alterada - contexto:', {
          isAlteracao: this.isAlteracao,
          acaoTela: this.acaoTela,
          perfilHabilitador: this.$verificaPerfilHabilitador()
        });
        
        this.$nextTick(() => {
          this.ativarAlertContratoSocial();
        });
      }
    },

    onArquivoLimpo(doc) {
      doc.docSolicitacao.arquivoUpload = null;
      doc.file = null;
      
      if (this.isAlteracao) {
        doc.docSolicitacao.datExpedicao = null;
        this.dataContratoSocialKey++;
      }
      
      // Detectar exclusão do Contrato Social
      if (doc.codDocumento === 146) {
        console.log('DEBUG hab-juridica: Arquivo do Contrato Social removido - contexto:', {
          isAlteracao: this.isAlteracao,
          acaoTela: this.acaoTela
        });
        
        this.$nextTick(() => {
          this.ativarAlertContratoSocial();
        });
      }
    },

    onNovoArquivo(doc) {
      if (doc.codDocumento === 146) {
        console.log('DEBUG hab-juridica: Novo arquivo Contrato Social selecionado - contexto:', {
          isAlteracao: this.isAlteracao,
          acaoTela: this.acaoTela
        });
        
        this.$nextTick(() => {
          this.ativarAlertContratoSocial();
        });
      }
    },

    // Ativar alert e notificações (VERSÃO CENTRALIZADA)
    ativarAlertContratoSocial() {
      // Detectar se é perfil Cadastrador (se a função existir)
      var isPerfilCadastrador = false;
      if (this.$verificaPerfilCadastrador) {
        isPerfilCadastrador = this.$verificaPerfilCadastrador();
      }

      // Regra antiga: alteração "clássica"
      var emContextoAlteracao = false;

      if (this.isAlteracao && this.acaoTela === 'alterar') {
        emContextoAlteracao = true;
      }

      // ✅ NOVA REGRA:
      // Se for CADASTRADOR e estiver mexendo em uma solicitação já existente
      // (ou seja, não é um cadastro 100% novo), considerar como alteração também.
      if (!emContextoAlteracao && isPerfilCadastrador) {
        if (this.model && this.model.idFornecSolicitacao) {
          emContextoAlteracao = true;
        }
      }

      // Se mesmo assim não for considerado contexto de alteração, não dispara nada
      if (!emContextoAlteracao) {
        console.log(
          'DEBUG hab-juridica: Funcionalidade INATIVA - não emitir evento',
          {
            isAlteracao: this.isAlteracao,
            acaoTela: this.acaoTela,
            perfilCadastrador: isPerfilCadastrador
          }
        );
        return;
      }

      var timestamp = Date.now();

      // Determinar o "perfil" que será enviado no evento
      var perfil = 'fornecedor';
      if (this.$verificaPerfilHabilitador && this.$verificaPerfilHabilitador()) {
        perfil = 'validador';
      } else if (isPerfilCadastrador) {
        perfil = 'cadastrador';
      }

      console.log(
        'DEBUG hab-juridica: Emitindo contratoSocialAlterado com timestamp:',
        timestamp,
        'perfil:',
        perfil
      );

      // ✅ SÓ EMITIR EVENTO - mixin decidirá se há alteração real
      if (this.$root && this.$root.$emit) {
        this.$root.$emit('contratoSocialAlterado', {
          alterado: true,
          origem: 'habilitacao-juridica',
          timestamp: timestamp,
          novaAlteracao: true, // FLAG CRUCIAL
          perfil: perfil,
          contexto: {
            isAlteracao: this.isAlteracao,
            acaoTela: this.acaoTela,
            perfilCadastrador: isPerfilCadastrador
          }
        });
      }
    },


    //Remove validacao de documento caso um campo seja alterado 
    removeAprovacaoRejeicao(docSolicitacao){
      docSolicitacao.arquivoUploadSituacao  = null;
      docSolicitacao.idMotivoIndeferimentoArquivo = null;
      docSolicitacao.dtArquivoUploadRejeicao = null;
    },

    getDescricaoDocumento(doc){
      if( doc.codDocumento === 146 && this.model.flagEstrangeiro === '1'){
        return "CONTRATO SOCIAL COM TRADUÇÃO JURAMENTADA";
      }else{
        return doc.nomDocumento.toUpperCase();
      }
    },

    isAnexoValido(doc){
      return (doc.file != null || (!!doc.docSolicitacao['arquivoUpload'] && doc.docSolicitacao['arquivoUpload'] !== "Não Encontrado"));
    },
    
    // Método para quando arquivo do Contrato Social for alterado
    onContratoSocialChanged() {
      this.$toasted.info(
        'Atenção: A alteração do Contrato Social exige a atualização do Cartão CNPJ na aba "Regularidade Fiscal e Trabalhista"',
        {
          duration: 8000,
          position: 'top-center',
          className: 'custom-toast info'
        }
      );
      
      // Emitir evento para componente pai
      this.$emit('contratoSocialAlterado', true);
    }    
  }
};
</script>


<style>
.btn.focus, .btn:focus, .san {
    outline: 0;
    box-shadow: none!important;
    border: none;
}
.inputIcon {
  position: relative;
}

.inputIcon [type="file"] {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
}

.inputIcon .v-input__append-inner {
  margin-top: 0;
  padding-left: 0;
  text-align: center;
  width: 38px;
}

.inputIcon .v-text-field__slot {
  border-right: 0;
}

.inputIcon .v-input__icon--clear {
    border-radius: 0;
		border-right: 0 none !important;
}

.inputIcon .v-input__icon {
  align-self: center !important;
  min-height: 50px;
  border: solid 1px #eee;
  border-left: none;
  border-bottom: none;
  display: inline-block !important;
  vertical-align: middle !important;
}

.inputIcon .v-icon {
  padding: 13px 0 0 0;
}
</style>